import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import classNames from 'classnames/bind';
import { UserService } from '../../../services';
import type { User } from '../../../types';
import { Icon } from '../../atoms';
import { NavigationDrawer } from '../../organisms';
import style from './Users.module.scss';

const cx = classNames.bind(style);

// Example to Save routes for only authenticated users
// https://stackblitz.com/github/remix-run/react-router/tree/main/examples/auth?file=src%2FApp.tsx

export function Users(): JSX.Element {
  const navigate = useNavigate();

  const [users, setUsers] = useState<User[]>([]);

  useEffect(() => {
    UserService.getAllUsers().then((response) => {
      if (response.error) {
        toast.error('User konnten nicht geladen werden!');

        return;
      }
      const data = response.data as User[];
      if (data) {
        data.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
      }
      setUsers(data);
    });
  }, []);

  const pageClasses = cx('container');
  const pageHeaderClasses = cx('pageHeader');
  const userBoxClasses = cx({ UserBox: true });

  return (
    <div className={pageClasses}>
      <NavigationDrawer />
      <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
        <div className={pageHeaderClasses}>
          <Icon icon='user' size={70}></Icon>
          <span>
            <h1>Users</h1>
            <div>Anzahl: {users.length}</div>
          </span>
        </div>
        {users.map((user) => (
          <div key={user.id} className={userBoxClasses} onClick={() => navigate(`/user/${user.id}`)}>
            <div>
              {user.firstname} {user.lastname}
              <span style={{ fontWeight: 'lighter' }}> - {user.email}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
